export default {
  dashboard: {
    hello: "Bonjour Aichemy",
  },
};
